"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorLoadCreator = void 0;
var declineEventload_1 = require("../declinePaymentEventCreators/declineEventload");
var utils_1 = require("../utils");
var errorLoadCreator = function (event) {
    var eventData = {
        event: "error-load",
        eventInfo: "error-load",
        page: { error: event.eventData.message },
    };
    if (event.eventData.apiResponseCode != null) {
        var declineData = {
            apiResponseCode: event.eventData.apiResponseCode,
        };
        var declineEvent = (0, declineEventload_1.declineCodeEventLoad)(__assign(__assign({}, event), { eventData: declineData }));
        (0, utils_1.pushEvent)(declineEvent);
    }
    return eventData;
};
exports.errorLoadCreator = errorLoadCreator;
